module.exports = __webpack_public_path__ + "img/timeline-11.8c2b17a4.svg";